export default __webpack_public_path__ + "images/A7.1019996.png";